// extracted by mini-css-extract-plugin
module.exports = {"componentStyle":"LotteryTagList_componentStyle__973_M","itemLink":"LotteryTagList_itemLink__E9WqN"};